const invitationComfortQuestion = {
  name: 'invitationcomfort',
  title: 'Do you feel comfortable inviting others into your fitness goals?',
  type: 'radiogroup',
  choices: [
    {
      value: 'Yes',
      text: 'Yes',
    },
    {
      value: 'No',
      text: 'No',
    },
    {
      value: 'It depends',
      text: 'It depends',
    },
  ],
  isRequired: true,
};

export default invitationComfortQuestion;